import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamsListRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamsListRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamsListRequestDTORaw) {
    JsonSchemaValidator.assert(RoomStreamsListRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

export interface RoomStreamsListRequestDTORaw {
  roomId: RoomId;
}
